import "./App.css";
import Navbar from "./components/Navbar";
import Textform from "./components/Textform";
import About from "./components/About";
import Welcome from "./components/Welcome";
import NoteCard from "./components/NoteCard";
import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NoteState from "./context/notes/NoteState";
import Alert from "./components/Alert";
import Login from "./components/Login";
import Signup from "./components/Signup";

export default function App() {
  const [mode, setmode] = useState("light");
  const [alert, setalert] = useState(null);
  const showAlert = (message, type) => {
    setalert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setalert(null);
    }, 1800);
  };

  const togglemode = () => {
    if (mode === "light") {
      setmode("dark");

      document.body.style.backgroundColor = "#393e46";
      document.body.style.color = "white";
    } else {
      setmode("light");

      document.body.style.backgroundColor = "#eeeeee";
      document.body.style.color = "black";
    }
  };
  return (
    <NoteState>
      <Router>
        <Navbar
          mode={mode}
          togglemode={togglemode}
          theme={mode === "light" ? "Light" : "Dark"}
          showAlert={showAlert}
        />
        <Alert alert={alert} />
        <div className="container my-5">
          <Routes>
            <Route
              path="/text"
              element={<Textform heading="Write your note" mode={mode} showAlert={showAlert}/>}
            />
            <Route path="/about" element={<About />} />
            <Route exact path="/login" element={<Login showAlert={showAlert} />} />
            <Route exact path="/signup" element={<Signup showAlert={showAlert} />} />
            <Route path="/" element={<Welcome />} />
            <Route path="/yournotes" element={<NoteCard showAlert={showAlert} />} />
          </Routes>
        </div>
      </Router>
    </NoteState>
  );
}
